import React from "react";
import { FaGem, FaShieldAlt } from "react-icons/fa";
import { GiCrystalGrowth, GiLotus } from "react-icons/gi";

function CrystalFeatureSection() {
  const features = [
    {
      icon: <GiCrystalGrowth size={26} />,
      title: "100% Natural",
      desc: "Authentic stones, sourced ethically.",
    },
    {
      icon: <FaGem size={22} />,
      title: "Expertly Curated",
      desc: "Handpicked by crystal experts.",
    },
    {
      icon: <GiLotus size={26} />,
      title: "Healing Energy",
      desc: "Stones that inspire balance, healing & positivity.",
    },
    {
      icon: <FaShieldAlt size={22} />,
      title: "Trust & Quality",
      desc: "Quality you can trust, energy you can feel.",
    },
  ];

  return (
    <div className="crystal-feature-section">
      <div className="container">
        <div className="row g-4 g-lg-0">
          {features.map((item, index) => (
            <div className="col-6 col-lg-3" key={index}>
              <div className="crystal-feature-box">
                <div className="crystal-feature-icon">{item.icon}</div>
                <div className="crystal-feature-text">
                  <h6 className="crystal-feature-title">{item.title}</h6>
                  <p className="crystal-feature-desc">{item.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CrystalFeatureSection;